import { createReducer, on } from '@ngrx/store';
import { setLoading, setMap, setSectors, setSelectedSector, setShow, setView } from './map.actions';
import { Map, MapView } from '../models/Map';
import { MapPlace } from '../models/MapPlace';
import { Sector } from '../models/Sector';

export interface MapState {
  map: Map | null;
  sectors: Sector[];
  selectedSector: Sector | null;
  isShowing: boolean;
  view: MapView;
  isLoading: boolean;
};

export const initialState: MapState = {
  map: null,
  sectors: [],
  selectedSector: null,
  isShowing: false,
  view: MapView.PLACES,
  isLoading: false,
};

export const mapReducer = createReducer(
  initialState,
  on(setMap, (state, { map }) => ({ ...state, map })),
  on(setSectors, (state, { sectors }) => ({ ...state, sectors })),
  on(setSelectedSector, (state, { selectedSector }) => ({ ...state, selectedSector })),
  on(setShow, (state, { isShowing }) => ({ ...state, isShowing })),
  on(setView, (state, { view }) => ({ ...state, view })),
  on(setLoading, (state, { isLoading }) => ({ ...state, isLoading })),
);